import { render, staticRenderFns } from "./audio-group-block.vue?vue&type=template&id=045ba514&scoped=true"
import script from "./audio-group-block.vue?vue&type=script&lang=ts"
export * from "./audio-group-block.vue?vue&type=script&lang=ts"
import style0 from "./audio-group-block.vue?vue&type=style&index=0&id=045ba514&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ba514",
  null
  
)

export default component.exports